import { render, staticRenderFns } from "./SelectedColor.vue?vue&type=template&id=0322ec5d&"
import script from "./SelectedColor.vue?vue&type=script&lang=js&"
export * from "./SelectedColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports